import React from 'react';
import { 
  Container, 
  Row, 
  Col, 
  Modal, 
  ModalHeader, 
  ModalBody, 
  ModalFooter, 
  Button, 
  Label, 
  FormGroup, 
  Input, 
  Alert 
} from 'reactstrap';
import Async from 'react-select/async';
import moment from 'moment';
import { Link } from 'react-router-dom';
// Components
import CurrencyInput from 'components/CurrencyInput/CurrencyInput';
import Datetime from "react-datetime";
// Helpers
import { calculateVATByPrice,calculateTCP } from 'helpers/pricing';
import { getClientsRequest } from 'api/client';
// Styles
import './MarkAsReservedModal.css'
// Contexts
import ProjectContext from 'contexts/ProjectContext';

class MarkAsReservedModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      unit: {},
      modelsIndex: null,
      filtersClients: {},
      generateReservationPayment: false,
      reservation_date: null,
      reservation_amount: null,
      zero_vat: false
    };
    this.toggle = this.toggle.bind(this);
  }

  static contextType = ProjectContext;

  toggle() {
    const { selectedModel, client, models = [] } = this.props.selectedUnit
    let modelsIndex = selectedModel ? models.findIndex(x => x.name === selectedModel.name) : -1;
    let selectedClient;

    if (client) {
      selectedClient = {
        label: `${client.first_name} ${client.last_name}`,
        value: client._id,
        data: client
      }
    }

    this.setState((prevState) => ({
      modal: !prevState.modal,
      unit: {
        ...this.props.selectedUnit,
        client: selectedClient
      },
      modelsIndex
    }));
  }

  onChangeSelectedModelField = (e) => {
		const { target } = e;
		let { name, value } = target;
    
    const { unit, modelsIndex } = this.state
    const { price } = unit.selectedModel;

    if (name === 'price') {
      let vat = calculateVATByPrice(value)
      let tcp = calculateTCP(value, vat)

      this.setState(prevState => ({
        unit: {
          ...prevState.unit,
          selectedModel: {
            ...prevState.unit.selectedModel,
            [name]: value,
            vat,
            tcp
          }
        },
      }));
      
    } else if (name === 'discount') {
      let discountedPrice = value > 0 ? price - value : unit.models[modelsIndex].price 

      let vat = calculateVATByPrice(discountedPrice)
      let tcp = calculateTCP(discountedPrice, vat)

      this.setState(prevState => ({
        unit: {
          ...prevState.unit,
          selectedModel: {
            ...prevState.unit.selectedModel,
            [name]: value,
            vat,
            tcp
          }
        },
      }));
      
    } else {
      this.setState(prevState => ({
        unit: {
          ...prevState.unit,
          selectedModel: {
            ...prevState.unit.selectedModel,
           [name]: value,
          }
        },
      }));
    }
	}
  onChangeUnitField = (e) => {
		const { target } = e;
		let { name, value } = target;

    this.setState(prevState => ({
      unit: {
        ...prevState.unit,
        [name]: value,
      },
    }));
	}

  onChangeField = (e) => {
		const { target } = e;
		let { name, value } = target;

    this.setState({
      [name]: value,
    })
	}

  onSelectChange = (key) => (object)=> {
    const { models = [] } = this.props.selectedUnit
    const { value } = object.target
    const model = models[value]
    
    this.setState(prevState => ({
			unit: {
				...prevState.unit,
				[key]: model,
        price: model?.price,
        vat: model?.vat,
        tcp: model?.tcp,
			},
      modelsIndex: value
		}));
  }

  onChangeAsyncSelect = (key) => (object) => {
      const { unit } = this.state;

    if(!object) {
      this.setState({
          unit: {
              ...unit, 
              [key]: "",
          },
      })

      return;
    }

    this.setState({
      unit: {  
          ...unit,
          [key]: object,
      }
    })
  }

  onChangeCheckbox = (e) => {
		const { target } = e;
		const { name, checked } = target;
    const { unit } = this.state;

		if (name === "zero_vat") {

      let updatedVat;
      let updatedTcp;

      if (checked) {
        
        updatedVat = 0;
        updatedTcp = unit.selectedModel.discount ? unit.price - unit.selectedModel.discount : unit.price;

      } else {
        // Recalculate VAT and TCP
        updatedVat = unit.price * 0.12;
        updatedTcp = unit.price + updatedVat;
      }

      this.setState(prevState => ({
        unit: {
          ...prevState.unit,
          selectedModel: {
            ...prevState.unit.selectedModel,
            vat: updatedVat,
            tcp: updatedTcp,
          }
        },
        [name]: checked,
      }));

		} else {
			this.setState({
        [name]: checked,
      });
		}

		
	}

  loadClients = async (search, callback) => {
		const { filtersClients } = this.state;
    const { selectedProject } = this.context;

    filtersClients.project = selectedProject;

		this.setState({
			filtersClients: {
				...filtersClients,
				search
			}
		})

		if(search) {
			const clientResponse = await getClientsRequest(filtersClients);
			const clients = clientResponse.clients.map(client => {
				return {
					data: client,
					label: `${client.first_name} ${client.last_name}`,
					value: client._id
				}
			})
			callback(clients);
		}
	}

  render() {
    const { 
       backdrop = false,
       onSave,
       loading,
       error
      } = this.props;

      const {
        selectedModel,
        client,
        _id,
        sellerBonus,
        models = []
      } = this.state.unit

      const {
        unit,
        generateReservationPayment,
        reservation_date,
        reservation_amount,
        zero_vat
      } = this.state

      const saveData = {
        unit,
        generateReservationPayment,
        reservation_date,
        reservation_amount
      }

    return (
      <Modal backdrop={backdrop} className="mark-reserved" isOpen={this.state.modal} toggle={this.toggle} style={{marginTop: '-120px'}}>
        <ModalHeader toggle={this.toggle}>Mark Selected Unit as Reserved</ModalHeader>
        <ModalBody>
          <Container className="p-2">
            <Row>
              <Col>
                <FormGroup>
                  <Label>Client<span className="required-start">*</span></Label>
                  <Async
                      clearValue={""}
                      value={client}
                      name="client"
                      options={[]}
                      loadOptions={this.loadClients}
                      className="basic-multi-select "
                      classNamePrefix="select"
                      onChange={this.onChangeAsyncSelect('client')}
                      placeholder="Client..."
                      isClearable={true}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                    <Label>Selected Model<span className="required-start">*</span></Label>
                    <Input
                        type="select"
                        className="form-control pb-2"
                        name="models"
                        onChange={this.onSelectChange('selectedModel')}
                        value={this.state.modelsIndex}
                    >
                    <option style={{background: '#fff'}} value=''>{models.length > 0 ? 'Select a model' : "This unit doesn't have a model" }</option>
                        {models.map(({name, notAvailable}, count) => {
                          if(!notAvailable) {
                            return (
                                <option style={{background: '#fff'}} key={name} value={count}>{name}</option>
                            )
                          }
                          return 0
                        })}
                    </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                { models.length === 0 &&
                  <Alert color="warning">
                    <Link style={{color: 'white', fontWeight: '500'}} to={`/unit/edit?id=${_id}`}>
                      <u>Click here to add models to unit</u>
                    </Link> 
                  </Alert>
                }
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label>Price <span className="required-start">*</span></Label>
                  <CurrencyInput
										name="price"
										placeholder="Price"
										price={selectedModel?.price || 0}
										onChange={(value) => this.onChangeSelectedModelField({ target: { name: "price", value } })}
									/>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label>Discount</Label>
                  <CurrencyInput
										name="discount"
										placeholder="Discount"
										price={selectedModel?.discount || 0}
										onChange={(value) => this.onChangeSelectedModelField({ target: { name: "discount", value } })}
									/>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label>Discount details</Label>
                  <Input
										name="discount_details"
                    type="textarea"
										placeholder="Discount details"
										value={selectedModel?.discount_details || ""}
										onChange={(value) => this.onChangeSelectedModelField({ target: { name: "discount_details", value: value.target.value } })}
									/>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label>VAT <span className="required-start">*</span></Label>
                  <CurrencyInput
										name="vat"
										placeholder="VAT"
										price={selectedModel?.vat || 0}
										onChange={(value) => this.onChangeSelectedModelField({ target: { name: "vat", value } })}
									/>
                </FormGroup>
                <FormGroup check className="my-2">
                  <Label check>
                      <Input 
                          type="checkbox"
                          name="zero_vat"
                          onChange={e => this.onChangeCheckbox(e)}
                          checked={zero_vat}
                      />
                      <span className="form-check-sign" />
                      Zero VAT
                  </Label>
              </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label>TCP <span className="required-start">*</span></Label>
                  <CurrencyInput
										name="tcp"
										placeholder="TCP"
										price={selectedModel?.tcp || 0}
										onChange={(value) => this.onChangeSelectedModelField({ target: { name: "tcp", value } })}
									/>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label>Seller Bonus</Label>
                  <Input
										name="sellerBonus"
										placeholder="Seller Bonus"
										value={sellerBonus || ""}
										onChange={this.onChangeUnitField}
									/>
                </FormGroup>
              </Col>
            </Row>
            <FormGroup>
              <div className="form-check">
                <label className="form-check-label">
                  <input className="form-check-input" onChange={this.onChangeCheckbox} name="generateReservationPayment" type="checkbox" checked={!!generateReservationPayment} />
                  Generate Reservation Payment
                  <span className="form-check-sign">
                    <span className="check"></span>
                  </span>
                </label>
              </div>
            </FormGroup>
            {generateReservationPayment && 
              <>
                <FormGroup>
                  <Label>Reservation Date <span className="required-start">*</span></Label>
                  <Datetime
                    inputProps={{
                      className: "form-control",
                      placeholder: "Reservation Date",
                      name: "reservation_date"
                    }}
                    dateFormat="MM/DD/YYYY"
                    timeFormat={false}
                    value={typeof reservation_date === 'string' ? moment(reservation_date).format("MM/DD/YYYY") : reservation_date}
                    onChange={(date) => this.onChangeField({target: { value: moment(date).format("MM/DD/YYYY"), name: "reservation_date" }})}
                    closeOnSelect={true}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Reservation Amount <span className="required-start">*</span></Label>
                  <CurrencyInput 
                    name="reservation_amount"
                    price={reservation_amount || 0}
                    onChange={(value) => this.onChangeField({ target: { name: "reservation_amount", value } })}
                    placeholder="Reservation Amount"
                  />
                </FormGroup>
              </>
            }
            {error && 
              <Alert color="danger">
                {error.message}
              </Alert>
            }
          </Container>
        </ModalBody>
        <ModalFooter className="justify-content-end">
            <Button 
                color="primary" 
                className="btn-success-override mr-2" 
                onClick={() => onSave(saveData)}
                disabled={loading}
            >
                {loading ? "Saving" : "Save"}
            </Button>
            <Button color="secondary" className="btn-danger-override" onClick={this.toggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default MarkAsReservedModal;
